import { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { DESTINATIONS, IMG } from "@/data/platform";

export const IndiaMap = () => {
  const [active, setActive] = useState(DESTINATIONS.find((d) => d.slug === "coorg"));
  return (
    <div className="grid lg:grid-cols-2 gap-10 items-center">
      <div className="relative max-w-md mx-auto w-full aspect-[848/1264]" data-testid="india-map">
        <img src={IMG.indiaMap} alt="Map of India" className="absolute inset-0 w-full h-full object-cover rounded-3xl" />
        {DESTINATIONS.map((d) => (
          <button
            key={d.slug}
            data-testid={`map-marker-${d.slug}`}
            onClick={() => setActive(d)}
            aria-label={d.name}
            style={{ left: `${d.map.x}%`, top: `${d.map.y}%`, zIndex: active.slug === d.slug ? 20 : 10 }}
            className="absolute -translate-x-1/2 -translate-y-1/2 group hover:z-30 p-1"
          >
            <span className={`block h-3.5 w-3.5 rounded-full border-2 border-[#F7F5F0] shadow-md transition-all duration-300 ${active.slug === d.slug ? "bg-[#AD6A48] scale-150" : "bg-[#2D372B] group-hover:bg-[#AD6A48] group-hover:scale-125"}`} />
            <span className={`pointer-events-none absolute left-1/2 -translate-x-1/2 top-5 whitespace-nowrap text-[10px] font-semibold uppercase tracking-wider px-1.5 py-0.5 rounded bg-[#2D372B] text-[#F7F5F0] transition-opacity ${d.slug === "andaman" || active.slug === d.slug ? "opacity-100" : "opacity-0 group-hover:opacity-100"}`}>
              {d.slug === "andaman" ? "Andaman Is." : d.name}
            </span>
          </button>
        ))}
      </div>
      <div key={active.slug} data-testid="map-active-panel" className="bg-white border border-[#E5E2D9] rounded-3xl overflow-hidden">
        <div className="aspect-[16/8] overflow-hidden">
          <img src={active.image} alt={active.name} className="w-full h-full object-cover" loading="lazy" />
        </div>
        <div className="p-7">
          <div className="overline mb-1">{active.region} · {active.bestSeason}</div>
          <h3 className="font-serif-display text-3xl text-[#2D372B]">{active.name}</h3>
          <p className="text-sm text-[#5C665A] mt-2 leading-relaxed">{active.tagline}</p>
          <div className="mt-4 flex flex-wrap gap-1.5">
            {active.interests.map((i) => (
              <span key={i} className="text-xs rounded-full bg-[#89937C]/10 border border-[#89937C]/30 px-3 py-1 text-[#5C665A]">{i}</span>
            ))}
          </div>
          <Link to={`/destinations/${active.slug}`} data-testid="map-explore-link" className="mt-5 inline-flex items-center gap-1.5 text-[#AD6A48] font-medium hover:text-[#8A5236] transition-colors">
            <MapPin size={15} /> Explore {active.name} <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
};
